import { render } from "./TradingViewWidget.vue?vue&type=template&id=0d93ca37&scoped=true"
import script from "./TradingViewWidget.vue?vue&type=script&lang=js"
export * from "./TradingViewWidget.vue?vue&type=script&lang=js"

import "./TradingViewWidget.vue?vue&type=style&index=0&id=0d93ca37&scoped=true&lang=css"

import exportComponent from "/var/www/MERCANTIL/helpdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d93ca37"]])

export default __exports__